const DEFAULT_CATEGORIES = [
  "All",
  "Photography",
  "Video",
  "Drone",
  "Roadworks",
  "Structures",
  "People",
  "Night Works",
  "Depots",
  "Plant",
  "Traffic Management",
  "Events",
];

export default function FilterBar({
  active,
  onChange,
  categories = DEFAULT_CATEGORIES,
}) {
  return (
    <div
      data-testid="filter-bar"
      className="flex gap-2 flex-wrap items-center"
    >
      {categories.map((c) => (
        <button
          key={c}
          onClick={() => onChange(c)}
          data-testid={`filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
          className={`hl-chip ${active === c ? "active" : ""}`}
        >
          {c}
        </button>
      ))}
    </div>
  );
}
